import { useQuery } from '@tanstack/react-query';

import useWorkflowNudge from 'hooks/useWorkflowNudge';
import { indexWorkflowLogs, workflowQueryKeys } from 'services/api/workflows';

const FALLBACK_POLL_INTERVAL_MS = 60_000;

/**
 * The referral's activity feed (OLIO-2478). Rides the same WorkflowChannel nudge
 * as the referral itself (see useWorkflowNudge); the slow poll covers dropped
 * sockets and missed events, and stops once the run is terminal — a decided
 * referral's feed can no longer change (append-only, writes are rejected).
 */
export default function useWorkflowLogs(id: string | undefined, { isTerminal = false } = {}) {
  const query = useQuery({
    queryKey: workflowQueryKeys.logs(id ?? 'missing'),
    queryFn: ({ signal }) => indexWorkflowLogs(id!, signal),
    enabled: !!id,
    refetchInterval: isTerminal ? false : FALLBACK_POLL_INTERVAL_MS,
  });

  useWorkflowNudge(id, workflowQueryKeys.logs(id ?? 'missing'));

  return {
    entries: query.data ?? [],
    isLoading: query.isPending && !!id,
    isError: query.isError,
  };
}
